import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrap = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background: var(--background-color, #0a0e1a);
  color: var(--text-primary, #fff);
`;

const Card = styled.div`
  max-width: 520px;
  width: 100%;
  padding: 2rem;
  border-radius: 16px;
  background: rgba(18, 18, 28, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
`;

const Title = styled.h1`
  font-family: var(--font-display);
  font-size: 1.5rem;
  margin: 0 0 0.75rem;
`;

const Text = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 1.5rem;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled.button`
  background: var(--primary-color);
  color: #fff;
  font-weight: 700;
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid rgba(var(--primary-rgb), 0.65);
    outline-offset: 2px;
  }
`;

const LinkButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: var(--text-primary);
  font-weight: 700;
  padding: 0.75rem 1.25rem;
  border-radius: 10px;

  &:focus-visible {
    outline: 2px solid rgba(var(--primary-rgb), 0.65);
    outline-offset: 2px;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('[ErrorBoundary]', error, info);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Wrap id="main-content">
          <Card role="alert">
            <Title>Something went wrong</Title>
            <Text>
              FounderDNA hit an unexpected error. Your data on this device is unchanged. Try reloading or return home.
            </Text>
            <Actions>
              <Button type="button" onClick={this.handleRetry}>
                Return home
              </Button>
              <LinkButton to="/contact">Contact support</LinkButton>
            </Actions>
          </Card>
        </Wrap>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
